import { withRouter } from 'react-router-dom';

import TeamCallGroup from './TeamCallGroup';

export default withRouter(TeamCallGroup);
